<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import CBaseBlock from '@/presentation/components/base/CBaseBlock.vue'
import { useEMethodosStore } from '@/presentation/stores/emethodos/emethodos.ts'
import CEMethodosListItem from '@/presentation/components/emethodos/CEMethodosListItem.vue'
import { default as PInput } from 'primevue/inputtext'
import { default as PInputIcon } from 'primevue/inputicon'
import { default as PIconField } from 'primevue/iconfield'
import { default as PMultiSelect } from 'primevue/multiselect'
import { computed, type Ref, ref } from 'vue'

const { eMethodos } = storeToRefs(useEMethodosStore())

const search = ref('')
const tags: Ref<string[]> = ref([])

/**
 * Filtered results when apply filter
 */
const filtered = computed(() => {
  return eMethodos.value.filter((item) => {
    const searchFilter =
      search.value.trim() !== ''
        ? item.title.toLowerCase().includes(search.value.trim().toLowerCase())
        : true
    const tagsFilter = tags.value.length === 0 ? true : tags.value.includes(item.tags[0])
    return searchFilter && tagsFilter
  })
})

/**
 * Tag Options for multi-select
 */
const tagOptions = computed(() => {
  return Array.from(new Set(eMethodos.value.flatMap((item) => item.tags))).map((tag) => ({
    label: tag,
    value: tag
  }))
})
</script>

<template>
  <div class="mb-4 grid grid-cols-12 gap-2">
    <p-icon-field class="col-span-12 md:col-span-3">
      <p-input-icon class="pi pi-search" />
      <p-input id="search" v-model="search" placeholder="Recherche par titre" class="w-full" />
    </p-icon-field>
    <p-multi-select
      class="col-span-12 md:col-span-2 w-full"
      v-model="tags"
      :options="tagOptions"
      option-label="label"
      option-value="value"
      placeholder="Recherche par tags"
    />
  </div>
  <c-base-block :toggleable="false" title="Liste des e-methodos">
    <div v-if="eMethodos.length > 0" class="col-span-12 mt-4 grid w-full grid-cols-12 gap-4">
      <template v-for="item in filtered" :key="item.id">
        <div class="col-span-12 lg:col-span-2">
          <c-e-methodos-list-item :e-methodo="item" />
        </div>
      </template>
    </div>
    <p class="" v-else>Il n’y a aucun e-methodos.</p>
  </c-base-block>
</template>
